import { OUT_INVOICE, OUT_REFUND } from "./invoicesConstants";

export function formatType(type) {
    if (type === OUT_INVOICE)
        return "Facture de vente";
    else if (type === OUT_REFUND)
        return "Avoir de vente";

    return type;
}
